import { render, staticRenderFns } from "./yearColumn.vue?vue&type=template&id=6f3b98da"
import script from "./yearColumn.vue?vue&type=script&lang=js"
export * from "./yearColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports